export default "__VITE_ASSET__DhWLOj14__"